import { RotateCcw, WifiOff } from 'lucide-react';
import { isNetworkFailure } from '../../api/client';
import { Button, CenteredSpinner, EmptyState, ErrorBox } from '../../components/ui';
import { useT } from '../../i18n';
import { errorText } from './format';

export interface QueryLike {
  isError: boolean;
  error: unknown;
  fetchStatus: 'fetching' | 'paused' | 'idle';
  refetch: () => unknown;
}

/**
 * Loading / error / offline-without-data states for a query that has no data yet.
 * Render it only when `data` is undefined.
 */
export function QueryStatus({ q }: { q: QueryLike }) {
  const t = useT();
  const { isError, error, refetch } = q;
  const offline = q.fetchStatus === 'paused' || (isError && isNetworkFailure(error));
  if (!isError && !offline) return <CenteredSpinner label={t('common.loading')} />;
  if (offline) {
    return (
      <EmptyState
        icon={WifiOff}
        title={t('common.offline')}
        action={
          <Button variant="secondary" icon={RotateCcw} onClick={() => void refetch()}>
            {t('common.retry')}
          </Button>
        }
      >
        {t('common.no_data_offline')}
      </EmptyState>
    );
  }
  return (
    <ErrorBox onRetry={() => void refetch()} retryLabel={t('common.retry')}>
      {errorText(t, error)}
    </ErrorBox>
  );
}
